module.exports = __webpack_public_path__ + "img/warining-success.0cca471e.png";